export const adCard = {
    card: 'relative overflow-hidden transition-all outline-none',
    cardOutline: 'sf-ad-outline',
    cardShadow: 'sf-ad-card rounded-8',
    interactive: 'sf-ad-interactive',
    link: 'link link--dark sf-ad-link',
};

export const adImage = {
    image: 'w-full h-full object-center',
    contain: 'object-contain',
    crop: 'object-cover',
};

export const carousel = {
    list: 'overflow-x-scroll overflow-y-hidden overscroll-x-none',
    noScrollList: 'overflow-x-hidden overflow-y-hidden',
    bleed: 'sf-carousel-bleed',
    contain: 'sf-carousel-contain',
    smoothScroll: 'sf-scroll-behavior-smooth',
    scrollSnap: 'sf-carousel-snap',
    scrollbarHidden: 'sf-no-scrollbar',
};

export const categoryPill = {
    pill: 'h-40 flex items-center bg-bluegray-100 hover:bg-bluegray-200 px-14 rounded-full hover:no-underline',
    icon: 'sf-category-icon mr-8',
    text: 'text-primary text-14 font-bold',
};

export const chip = {
    card: 'flex items-center rounded-8 pr-16',
    noImage: 'pl-16',
    unselected: 'bg-white hover:bg-bluegray-100 shadow',
    selected: 'bg-bluegray-100 hover:bg-bluegray-200 sf-outline-blue-500',
    image: 'w-40 h-40 mr-10 object-cover object-center rounded-tl-8 rounded-bl-8',
    text: 'text-12 py-12',
};

export const collectionCard = {
    card: 'relative sf-collection-card rounded-8',
    aspectRatio: 'aspect-w-1 aspect-h-1 lg:aspect-w-3 lg:aspect-h-2',
    image: 'sf-collection-image rounded-8 transition-all',
    heading: 'mb-0 mt-8 text-16 break-words',
    link: 'sf-collection-link',
};

export const shelf = {
    header: 'flex items-center justify-between mb-16',
    title: 'h3 mb-0',
    fade: 'sf-shelf-fade',
    pagingToolbar: 'hidden lg:flex items-center',
    pagingLabel: 'text-12 text-gray-500 mr-16',
    pagingButton: 'button button--pill sf-shelf-button p-0',
};
